import {DrawerSeeker} from "@ui-seeker/core";
import {Grid} from "@mui/material";
import React from "react"
import {isEditUserSettingsSitesGroupDrawer, isOpenUserSettingsSitesGroupDrawer, userSettingsSitesGroupFormData} from "../../@signals";
import UserSettingSitesGroupDrawerName from "./Name";
import UserSettingSitesGroupDrawerSites from "./Sites";
import UserSettingSitesGroupDrawerSubmit from "./SubmitButton";

export default function UserSettingSitesGroupDrawer(){
    return <DrawerSeeker
        hideActions
        title={isEditUserSettingsSitesGroupDrawer.value ? "Edit site group" : "New site group"}
        isOpen={isOpenUserSettingsSitesGroupDrawer.value}
        controller={() => userSettingsSitesGroupFormData.value = { }}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <UserSettingSitesGroupDrawerName />
            </Grid>
            <Grid item xs={12}>
                <UserSettingSitesGroupDrawerSites />
            </Grid>
            <Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
                <UserSettingSitesGroupDrawerSubmit />
            </Grid>
        </Grid>
    </DrawerSeeker>
}